import type { Translations } from '../types';

export const es: Translations = {
  // Navigation
  nav: {
    home: 'Inicio',
    meditations: 'Meditaciones',
    journal: 'Diario',
    tasks: 'Tareas',
    balance: 'Balance',
    profile: 'Perfil',
  },

  // Common
  common: {
    loading: 'Cargando...',
    save: 'Guardar',
    saving: 'Guardando...',
    cancel: 'Cancelar',
    back: 'Atrás',
    continue: 'Continuar',
    skip: 'Omitir',
    search: 'Buscar',
    all: 'Todo',
    today: 'Hoy',
    yesterday: 'Ayer',
    daysAgo: 'd. atrás',
    weeksAgo: 'sem. atrás',
    minutes: 'min',
    days: 'días',
    friend: 'amigo',
  },

  // Home page
  home: {
    goodMorning: 'Buenos días',
    goodAfternoon: 'Buenas tardes',
    goodEvening: 'Buenas noches',
    howAreYou: '¿Cómo estás hoy?',
    trackMood: 'Rastrea tu estado emocional y progreso',
    shareMood: 'Comparte tu estado de ánimo',
    loadingMeditations: 'Cargando meditaciones...',
    popularToday: 'Popular hoy',
    popularNow: 'Popular ahora',
    forSleep: 'Para dormir',
    practiceCalendar: 'Calendario de práctica',
    dailyWisdom: 'Sabiduría del día',
    wisdomQuote: '"La felicidad no está en hacer siempre lo que quieres, sino en querer siempre lo que haces."',
  },

  // Profile page
  profile: {
    memberSince: 'Con nosotros desde',
    consecutive: 'Consecutivos',
    balance: 'Balance',
    myFriends: 'Mis amigos',
    friends: 'Amigos',
    earned: 'Ganado',
    inviteFriend: 'Invita a un amigo',
    getCrystalsPerFriend: 'Obtén {amount} 💎 por cada amigo',
    copyLink: 'Copiar enlace',
    copied: '¡Copiado!',
    copyAndSend: 'Copia y envía el enlace a un amigo',
    invitedFriends: 'Amigos invitados',
    joined: 'Se unió',
    noFriendsYet: 'Nadie se ha unido a través de tu enlace aún',
    settings: 'Configuración',
    myPreferences: 'Mis preferencias',
    notifications: 'Notificaciones',
    support: 'Soporte',
    aboutApp: 'Acerca de la app',
    language: 'Idioma',
  },

  // Onboarding
  onboarding: {
    welcome: 'Hola',
    welcomeTitle: 'Hola.\nSoy SanaSivana, el camino hacia la armonía interior',
    welcomeSubtitle: 'Si las cosas son difíciles para ti, estás en el lugar correcto. Aquí puedes encontrar paz a través de la meditación, ordenar tus pensamientos y encontrar armonía.',
    experienceTitle: 'Tu experiencia en meditación',
    experienceSubtitle: 'Cuéntanos sobre tu experiencia para que podamos seleccionar las prácticas adecuadas',
    beginner: 'Principiante',
    beginnerDesc: 'Apenas empiezo a conocer la meditación',
    intermediate: 'Algo de experiencia',
    intermediateDesc: 'He practicado algunas veces',
    advanced: 'Practico regularmente',
    advancedDesc: 'Medito constantemente',
    goalsTitle: 'Tus objetivos',
    goalsSubtitle: '¿Qué quieres lograr con la meditación? Puedes seleccionar varias opciones.',
    reduceStress: 'Reducir el estrés',
    improveSleep: 'Mejorar el sueño',
    increaseFocus: 'Aumentar la concentración',
    manageEmotions: 'Gestionar emociones',
    findPeace: 'Encontrar paz interior',
    preferencesTitle: 'Tus preferencias',
    preferencesSubtitle: '¿Qué tipos de meditación te interesan y cuánto tiempo estás dispuesto a dedicar a la práctica?',
    meditationTypes: 'Tipos de meditación',
    mindfulness: 'Mindfulness',
    breathingPractices: 'Prácticas de respiración',
    visualization: 'Visualización',
    mantras: 'Mantras',
    bodyScan: 'Escaneo corporal',
    sessionDuration: 'Duración de la sesión',
    congratulations: '¡Felicitaciones!',
    rewardReceived: 'Recibiste una recompensa por completar la introducción',
    continueEarning: 'Continúa completando tareas y gana más 💎 para desbloquear meditaciones',
    startJourney: 'Comenzar el viaje',
  },

  // Balance page
  balancePage: {
    title: 'Balance',
    yourBalance: 'Tu balance:',
    transactionHistory: 'Historial de transacciones',
    income: 'Ingreso',
    expense: 'Gasto',
    noTransactions: 'No hay transacciones para mostrar',
  },

  // Tasks page
  tasksPage: {
    title: 'Tareas',
    subtitle: 'Completa tareas y gana cristales automáticamente',
    achievements: 'Logros',
    newbie: 'Novato',
    week: 'Semana',
    month: 'Mes',
    expert: 'Experto',
    completed: 'Completado',
    earned: 'Ganado',
    allTasks: 'Todas las tareas',
    loadingTasks: 'Cargando tareas...',
  },

  // Friends page
  friendsPage: {
    title: 'Amigos',
    searchPlaceholder: 'Buscar por nombre o username...',
    searchResults: 'Resultados de búsqueda',
    searching: 'Buscando...',
    noResults: 'No se encontró a nadie',
    friendRequests: 'Solicitudes de amistad',
    myFriends: 'Mis amigos',
    noFriendsYet: 'Aún no tienes amigos',
    findFriends: 'Encuentra amigos usando la búsqueda arriba',
    alreadyFriends: 'Amigos',
    requestSent: 'Solicitud enviada',
    wantsToAdd: 'Quiere agregarte',
    add: 'Agregar',
    sending: 'Enviando...',
    noPractices: 'Sin prácticas',
    lastPractice: 'Última práctica:',
    medit: 'medit.',
    tasksShort: 'tareas',
    user: 'Usuario',
  },

  // Meditation
  meditation: {
    catalog: 'Catálogo de meditaciones',
    catalogSubtitle: 'Video meditaciones para mejorar tu estado interior',
    loadingMeditations: 'Cargando meditaciones...',
    category: 'Categoría',
    difficulty: 'Dificultad',
    allLevels: 'Todos los niveles',
    breathing: 'Respiración',
    meditationType: 'Meditación',
    relaxation: 'Relajación',
    anxiety: 'Ansiedad',
    sleep: 'Sueño',
    beginner: 'Principiante',
    intermediate: 'Intermedio',
    advanced: 'Avanzado',
    noMeditations: 'No se encontraron meditaciones',
    tryFilters: 'Intenta cambiar los filtros',
    startMeditation: 'Iniciar meditación',
    startFor: 'Iniciar meditación por',
    yourBalance: 'Tu balance:',
    paid: 'Pagado',
    free: 'Gratis',
    inProgress: 'En progreso',
    completed: 'Completado',
    requiresCrystals: 'Requiere 💎 {cost} para ver',
    description: 'Descripción',
    instructions: 'Instrucciones',
    author: 'Autor',
    meditationCompleted: '¡Meditación completada!',
    greatJob: '¡Excelente trabajo! Continúa practicando regularmente.',
    notFound: 'Meditación no encontrada',
    backToCatalog: 'Volver al catálogo',
    loadingMeditation: 'Cargando meditación...',
    costAlert: 'Esta meditación cuesta 💎 {cost}. Haz clic en "Iniciar meditación" para pagar y ver.',
    audioMeditation: 'Meditación de audio',
  },

  // Journal
  journal: {
    title: 'Diario de estados',
    subtitle: 'Rastrea tu estado emocional',
    addEntry: 'Agregar entrada',
    noEntries: 'Aún no hay entradas',
    startJournal: 'Comienza a escribir un diario para entender mejor tus emociones',
    loadingEntries: 'Cargando entradas...',
    newEntry: 'Nueva entrada',
    howDoYouFeel: '¿Cómo te sientes?',
    great: 'Genial',
    good: 'Bien',
    okay: 'Normal',
    bad: 'Mal',
    terrible: 'Terrible',
    note: 'Nota',
    notePlaceholder: 'Describe lo que pasó hoy, cómo te sientes...',
    activitiesOptional: 'Actividades (opcional)',
    meditationActivity: 'Meditación',
    work: 'Trabajo',
    reading: 'Lectura',
    yoga: 'Yoga',
    social: 'Social',
    walk: 'Caminata',
    selectMood: 'Por favor, selecciona un estado de ánimo',
    addNote: 'Por favor, agrega una nota',
    savedSuccessfully: '¡Entrada guardada exitosamente!',
    saveFailed: 'Error al guardar la entrada. Inténtalo de nuevo.',
    unsavedWarning: '¿Estás seguro? Los datos no guardados se perderán.',
  },

  // Preferences
  preferences: {
    title: 'Mis preferencias',
    meditationExperience: 'Experiencia en meditación',
    experienceDescription: 'Cuéntanos sobre tu experiencia en meditación',
    meditationGoals: 'Objetivos de meditación',
    goalsDescription: '¿Qué quieres lograr? (puedes seleccionar varios)',
    meditationTypes: 'Tipos de meditación',
    typesDescription: '¿Qué prácticas te interesan? (puedes seleccionar varios)',
    sessionDuration: 'Duración de la sesión',
    durationDescription: '¿Cuánto tiempo estás dispuesto a dedicar a la meditación?',
    saveChanges: 'Guardar cambios',
  },

  // Notifications
  notifications: {
    title: 'Notificaciones',
    reminders: 'Recordatorios',
    updates: 'Actualizaciones',
    settingsHint: 'La configuración se aplica a las notificaciones que enviamos a Telegram.',
    loadingSettings: 'Cargando configuración...',
  },

  // Support
  supportPage: {
    title: 'Soporte',
    newTicket: 'Nuevo ticket',
    subject: 'Asunto',
    subjectPlaceholder: 'Describe brevemente el problema',
    enterSubject: 'Ingresa el asunto',
    subjectTooLong: 'El asunto es demasiado largo',
    problemDescription: 'Descripción del problema',
    descriptionPlaceholder: 'Describe tu problema o pregunta en detalle...',
    enterMessage: 'Ingresa el mensaje',
    messageTooLong: 'El mensaje es demasiado largo',
    submitTicket: 'Enviar ticket',
    submitting: 'Enviando...',
    createError: 'Error al crear el ticket. Inténtalo más tarde.',
    openTickets: 'Tickets abiertos',
    ticketOpen: 'Abierto',
    supportTeam: 'Soporte: ',
    you: 'Tú: ',
    ticketsHistory: 'Historial de tickets',
    allTickets: 'Todos los tickets, incluyendo cerrados',
  },

  // About
  about: {
    title: 'Acerca de la app',
    version: 'Versión',
    aboutSanaSivana: 'Acerca de SanaSivana',
    aboutDescription: 'SanaSivana es tu asistente personal para mantener la salud mental. Ofrecemos prácticas de meditación, ejercicios para reducir el estrés, diario de emociones y mucho más.',
    ourMission: 'Nuestra misión',
    missionDescription: 'Hacer que el apoyo a la salud mental sea accesible y simple para todos. Creemos que el cuidado del bienestar psicológico debe ser parte de la rutina diaria de cada persona.',
    information: 'Información',
    developer: 'Desarrollador',
    releaseDate: 'Fecha de lanzamiento',
    category: 'Categoría',
    healthFitness: 'Salud y fitness',
    legalInfo: 'Información legal',
    termsOfService: 'Términos de servicio',
    privacyPolicy: 'Política de privacidad',
    licenseAgreement: 'Acuerdo de licencia',
    copyright: '© 2025 SanaSivana. Todos los derechos reservados.',
  },

  // Language
  languagePage: {
    title: 'Idioma',
    selectLanguage: 'Selecciona idioma',
    english: 'English',
    russian: 'Русский',
    spanish: 'Español',
  },

  // Calendar
  calendar: {
    months: [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ],
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    previousMonth: 'Mes anterior',
    nextMonth: 'Mes siguiente',
    practiceDay: 'Día de práctica',
  },

  // Insufficient balance modal
  insufficientBalance: {
    title: 'Cristales insuficientes',
    required: 'Requerido:',
    youHave: 'Tienes:',
    missing: 'Faltan:',
    howToEarn: '¿Cómo ganar cristales?',
    completeTasks: 'Completa tareas',
    taskReward: 'Obtén hasta 30 cristales por tarea',
    inviteFriends: 'Invita amigos',
    friendReward: '15 cristales por cada amigo',
    practiceMeditations: 'Practica meditaciones',
    practiceReward: 'La práctica regular trae recompensas',
    topUpBalance: '💎 Recargar balance',
    goToTasks: 'Ir a tareas',
    inviteFriendsBtn: 'Invitar amigos',
  },

  // App loading
  appLoading: {
    loading: 'Cargando SanaSivana...',
    connectingTelegram: 'Conectando a Telegram...',
    verifyingAuth: 'Verificando autenticación...',
    checkingProgress: 'Verificando tu progreso...',
  },
};

